export default {
  rules: {
    required: 'This field is required',
    email: 'Please enter a valid email address',
    url: 'Please enter a valid URL',
    alpha: 'Only letters are allowed',
    alphaNum: 'Only letters and numbers are allowed',
    numeric: 'Only numbers are allowed',
    min: 'Must be at least {min}',
    max: 'Must not exceed {max}',
    minLength: 'Must be at least {min} characters long',
    maxLength: 'Must not exceed {max} characters',
    between: 'Must be between {min} and {max}',
    confirmed: 'Input does not match',
    date: 'Please enter a valid date',
    dateFormat: 'Date must be in {format} format',
    dateAfter: 'Date must be after {date}',
    dateBefore: 'Date must be before {date}'
  },
  fields: {
    name: 'Name',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    message: 'Message',
    phone: 'Phone Number',
    subject: 'Subject',
    comments: 'Comments',
    feedback: 'Feedback'
  }
}; 